module.exports = "images/10ans.43fcabee.png";